<script setup lang="ts">
import HeaderMenuLink from './Link.vue'
import SubMenuDesktopLayout from '~/components/App/NewHeader/Layouts/DesktopMenu/index.vue'
import HeaderMain from '~/components/App/NewHeader/HeaderMain/index.vue'
import HeaderSide from '~/components/App/NewHeader/HeaderSide/index.vue'
import { bus as layoutBus } from '@/layouts/default.vue'

interface Iprops {
  alt?: boolean
}

const props = defineProps<Iprops>()

const router = useRouter()
const filters = useFilters()

const itemsHeaderSide: InstanceType<typeof HeaderSide>['$props']['items'] = [
  {
    title: 'Snack It',
    text: 'Simplify your AI workflow',
    icon: 'magic-4',
    url: '/feature/snack-it',
  },
  {
    title: 'Free AI Images',
    text: 'Generate and collect free AI images',
    icon: 'global',
    url: '/',
    handler: () => {
      if (router.currentRoute.value.query.type)
        router.replace({ query: { type: undefined } })

      filters.value.type_ids = [2]
      filters.value.is_premium = false
      filters.value.item_type = 'prompt'

      layoutBus.emit('close-overlay')
      closeAllHeaderMenus()
    },
    beta: true,
  },
  {
    title: 'Lists',
    text: 'Create and sell lists of prompts',
    icon: 'list',
    url: '/list/create',
  },
  {
    title: 'Marketplace',
    text: 'Sell your prompts and buy from creators',
    icon: 'market',
    url: '/',
    handler: () => {
      filters.value.type_ids = [1]
      filters.value.is_premium = true
      filters.value.item_type = 'prompt'

      layoutBus.emit('close-overlay')
      closeAllHeaderMenus()
    },
    beta: true,
  },
]

function handleTopPromptsClick() {
  filters.value.item_type = 'prompt'
  filters.value.type_ids = [1]
  filters.value.interval = 0
  filters.value.is_premium = false

  layoutBus.emit('close-overlay')
  closeAllHeaderMenus()
}

function handleVisualPromptsClick() {
  if (router.currentRoute.value.query.type)
    router.replace({ query: { type: undefined } })
  filters.value.type_ids = [2]
  filters.value.item_type = 'prompt'
  filters.value.is_premium = false

  layoutBus.emit('close-overlay')
  closeAllHeaderMenus()
}

const openMenuState = useHeaderMenusActive()
const isOpen = computed(() => openMenuState.value.promptLibrary)
</script>

<template>
  <SubMenuDesktopLayout :active="isOpen" :alt="props?.alt">
    <template #main>
      <HeaderMain
        subtitle="snackprompt.com"
        subtitle-icon-background="#d7f55fbf"
        title="The Ultimate Prompt Library"
        description="The best AI prompts made by the community."
      >
        <template #image>
          <img class="image" src="~/assets/images/LucasHire/9d4efaafead08aa549df5c5d569efebf.webp">
        </template>

        <template #subtitleIcon>
          <div class="subtitle-icon">
            <IconLogo w-14px />
          </div>
        </template>

        <template #gridButtons>
          <HeaderMenuLink
            title="Top Prompts of All Time"
            description="View the Top Prompts"
            href="/"
            @click="handleTopPromptsClick"
          />
          <HeaderMenuLink
            title="Business Prompts"
            description="Increase Productivity"
            href="/topic/business"
          />
          <HeaderMenuLink
            title="Health & Wellness"
            description="Your own Fitness Coach"
            href="/topic/health-wellness"
          />
          <HeaderMenuLink
            title="Visual Prompts"
            description="Dall-E & Midjourney Prompts"
            href="/"
            @click="handleVisualPromptsClick"
          />
        </template>
      </HeaderMain>
    </template>

    <template #aside>
      <HeaderSide
        title="What's New"
        :items="itemsHeaderSide"
      />
    </template>
  </SubMenuDesktopLayout>
</template>

<style scoped lang="scss">
.subtitle-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(255, 136, 236, 0.20);
}

.image {
  border-radius: 8px;
}
@media screen and (max-width: 1000px) {
  .grid-buttons-item {
    width: 100%;

    a {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
